//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      formInline: {
        user: '',
        region: ''
      },
      tableData: [{
        roleNum: '0000001',
        sysName: '法律合规门户',
        roleName: '总行超级管理员',
        roleType: '总行',
        roleExplain: '角色用户用于管理总行所有制度',
        roleStatus: '有效'
      }],
      roleData: [{
        type: '0000001-超级管理员',
        data: [{
          roleNum: '010000001',
          roleName: '系统读写权限',
          id: '0001'
        }, {
          roleNum: '010000001',
          roleName: '系统读写权限',
          id: '0002'
        }, {
          roleNum: '010000001',
          roleName: '系统读写权限',
          id: '0003'
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      data: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }]
    };
  },
  methods: {
    search: function search() {},
    reset: function reset() {},
    searchResource: function searchResource() {},
    cancelDailog: function cancelDailog() {},
    commit: function commit() {}
  }
};